import BossModel from "@/models/BossModel";
import Container from "@/models/PlatinumPage/Version/Container/Container";
import PublicImage from '@/models/PublicImage/PublicImage'
import PlatinumPage from "@/models/PlatinumPage/PlatinumPage";

export default class Version extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'platinum-page/version';

    /**
     *
     * @type {string}
     */
    static entity = 'platinumPageVersions';

    static fields() {
        return {
            id: this.number(null).nullable(),
            header_title_nl: this.attr(null),
            header_title_en: this.attr(null),
            header_subtitle_nl: this.attr(null),
            header_subtitle_en: this.attr(null),
            button_text_nl: this.attr(null),
            button_text_en: this.attr(null),
            button_link: this.attr(null),
            excerpt: this.attr(null),
            vertical_public_image_id: this.number(null).nullable(),
            horizontal_public_image_id: this.number(null).nullable(),
            horizontal_image_x_position: this.number(null).nullable(),
            horizontal_image_y_position: this.number(null).nullable(),
            platinum_page_id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            page: this.belongsTo(PlatinumPage, 'platinum_page_id'),
            containers: this.hasMany(Container, 'platinum_page_version_id'),
            verticalImage: this.belongsTo(PublicImage, 'vertical_public_image_id'),
            horizontalImage: this.belongsTo(PublicImage, 'horizontal_public_image_id'),
        }
    }

    static fetchByPlatinumPageId(platinumPageId) {
        return this.api()
            .limit(0)
            .where('platinum_page_id', platinumPageId)
            .get(true);
    }

    /**
     *
     * @param id
     * @returns {*}
     */
    static fetchContent(id) {
        return this.api()
            .with([
                'containers.elements.row.columns.elements.row.columns.elements.widget.widgetable',
                'containers.elements.row.columns.elements.widget.widgetable',
                'horizontalImage',
                'verticalImage',
            ])
            .find(id);
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Duplicate() {
        return this.constructor.api()
            .action(this.id + '/duplicate')
            .create(this);
    }

    /**
     *
     * @returns {boolean}
     * @constructor
     */
    IsPublished() {
        return this.id == this.PlatinumPage().platinum_page_version_id;
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     */
    pasteSelected(containersIds) {
        return this.constructor.api().action(this.id + '/paste').create({ids: containersIds}, false).then(result => {
            return Version.fetchContent(result.id);
        });
    }

    /**
     *
     * @param draft
     * @param containers
     */
    static updateChildRanks(draft, containers) {
        for (let key in containers) {
            if (Object.prototype.hasOwnProperty.call(containers, key) && containers[key].id !== undefined) {
                containers[key].platinum_page_draft_id = draft.id;
                containers[key].rank = key;
                containers[key].api().update();
            }
        }
    }

    /**
     *
     * @returns {Promise<AxiosResponse<T>>}
     * @constructor
     */
    Publish() {
        return this.constructor.api().action(this.id + '/publish').update(this).then(version => {
            let platinumPage = version.PlatinumPage();
            platinumPage.platinum_page_version_id = version.id;
            return version;
        });
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    PlatinumPage() {
        return this.getRelated('page');
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    HorizontalImage() {
        return this.getRelated('horizontalImage');
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    Containers() {
        return this.getRelated('containers');
    }
}
